import { Fragment, useState } from "react";
import withDashboard from "../../HOC/withDashboard";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ButtonBase,
  Button,
  InputAdornment,
  TextField,
  Card,
  CircularProgress,
} from "@mui/material";
import Pagination from "../../components/NewPagination";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import SearchIcon from "@mui/icons-material/Search";
import CallMadeIcon from "@mui/icons-material/CallMade";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import PreviewIcon from "@mui/icons-material/Preview";
import { fetchGetOrders } from "../../services/CustomReferralCodeService";
import {
  getOrderDetail,
  getOrders,
  setSearchOrder,
  setUser,
} from "../../redux/actions/userAction";
import { capitalize, formatNumberWithCommas } from "../../utils";
import "./index.css";
import noTransactionImg from "../../assets/transaction_eth.png";

const Orders = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);
  const [orderData, setOrderData] = useState([]);
  const [orderFilter, setOrderFilter] = useState({
    search: "",
    page: 0,
    limit: 10,
    type: "",
    status: "",
  });
  const User = useSelector(({ User }) => User);
  const {
    filteredOrders,
    paginatedOrders,
    currentOrderPage,
    totalOrderPages,
    orderPerPage,
    orderSearch,
    orderType,
    orderStatus,
  } = User;

  const getOrders = () => {
    setIsLoading(true);
    dispatch(fetchGetOrders(orderFilter))
      .then((res) => {
        setTotalData(res?.data?.data?.total);
        setOrderData(res?.data?.data?.data);
        setIsLoading(false);
      })
      .catch(({ message, errorData, statusCode }) => {
        console.error("Error fetching virtual card users:", message);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getOrders();
  }, [orderFilter]);

  const onChangeFilter = (name, value) => {
    setOrderFilter({ ...orderFilter, [name]: value });
  };

  // const setTotalPages = (totalpages) => {
  //   dispatch(
  //     setUser({
  //       name: "totalOrderPages",
  //       value: totalpages,
  //     })
  //   );
  // };
  // const setCurrentPage = (currentPage) => {
  //   dispatch(
  //     setUser({
  //       name: "currentOrderPage",
  //       value: currentPage,
  //     })
  //   );
  // };
  // const setPaginatedItems = (paginatedItems) => {
  //   dispatch(
  //     setUser({
  //       name: "paginatedOrders",
  //       value: paginatedItems,
  //     })
  //   );
  // };
  // const handleChangeRowsPerPage = (event) => {
  //   const value = event.target.value;
  //   dispatch(
  //     setUser({
  //       name: "orderPerPage",
  //       value,
  //     })
  //   );
  // };

  // const onSearch = (e) => {
  //   const value = e.target.value;
  //   dispatch(setSearchOrder(value));
  // };

  const onViewOrder = (order) => {
    const orderId = order._id;
    dispatch(
      getOrderDetail({
        data: {
          orderId,
        },
        navigate,
      })
    );
  };

  // useEffect(() => {
  //   dispatch(getOrders());
  //   // eslint-disable-next-line
  // }, []);

  // const changeOrderType = (type) => {
  //   dispatch(
  //     setUser({
  //       name: "orderType",
  //       value: type,
  //     })
  //   );
  //   dispatch(setSearchOrder(orderSearch));
  // };

  // const changeOrderStatus = (status) => {
  //   dispatch(
  //     setUser({
  //       name: "orderStatus",
  //       value: status,
  //     })
  //   );
  //   dispatch(setSearchOrder(orderSearch));
  // };

  return (
    <Fragment>
      <div className="table-layout-container">
        <div className="order-accordian-row">
          <div className="order-accordian-container">
            <ButtonBase>
              <div
                className={`order-accordian-item left ${
                  orderFilter?.type === "" && "selected"
                }`}
                onClick={() => onChangeFilter("type", "")}
              >
                All
              </div>
            </ButtonBase>
            <ButtonBase>
              <div
                className={`order-accordian-item ${
                  orderFilter?.type === "buy" && "selected"
                }`}
                onClick={() => onChangeFilter("type", "buy")}
              >
                Buy
              </div>
            </ButtonBase>
            <ButtonBase>
              <div
                className={`order-accordian-item right ${
                  orderFilter?.type === "sell" && "selected"
                }`}
                onClick={() => onChangeFilter("type", "sell")}
              >
                Sell
              </div>
            </ButtonBase>
          </div>
          <div className="order-status-accordian-container">
            <div className="order-accordian-container">
              <ButtonBase>
                <div
                  className={`order-accordian-item left ${
                    orderFilter?.status === "" && "selected"
                  }`}
                  onClick={() => onChangeFilter("status", "")}
                >
                  All
                </div>
              </ButtonBase>
              <ButtonBase>
                <div
                  className={`order-accordian-item  ${
                    orderFilter?.status === "pending" && "selected"
                  }`}
                  onClick={() => onChangeFilter("status", "pending")}
                >
                  Pending
                </div>
              </ButtonBase>
              <ButtonBase>
                <div
                  className={`order-accordian-item  ${
                    orderFilter?.status === "completed" && "selected"
                  }`}
                  onClick={() => onChangeFilter("status", "completed")}
                >
                  Completed
                </div>
              </ButtonBase>
              <ButtonBase>
                <div
                  className={`order-accordian-item right ${
                    orderFilter?.status === "rejected" && "selected"
                  }`}
                  onClick={() => onChangeFilter("status", "rejected")}
                >
                  Rejected
                </div>
              </ButtonBase>
            </div>
          </div>
        </div>
        <Card className="table-card">
          <div className="table-title">
            <span>List of Orders</span>
            <div>
              {/* <TextField
                fullWidth
                variant="standard"
                className="search-input"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon style={{ color: "white" }} />
                    </InputAdornment>
                  ),
                }}
                onChange={onSearch}
                value={orderSearch}
              /> */}
            </div>
          </div>
          <div className="table-container">
            <table>
              <thead>
                <th>Name</th>
                <th>Type</th>
                <th>Amount Sent</th>
                <th>Amount To Recieve</th>
                <th>Status</th>
                <th>Action</th>
              </thead>
              <tbody>
                {isLoading ? (
                  <div className="flex justify-center items-center p-4">
                    <CircularProgress />
                  </div>
                ) : (
                  orderData.length >= 1 &&
                  orderData.map((order) => {
                    const _amountSent =
                      order.type === "buy"
                        ? `${formatNumberWithCommas(order.amountSent)} ${
                            order.currency
                          }`
                        : `${order.amountSent} ${order.coin}`;
                    const _amountReceive =
                      order.type === "buy"
                        ? `${order.amountToRecieve} ${order.coin}`
                        : `${formatNumberWithCommas(order.amountToRecieve)} ${
                            order.currency
                          }`;
                    const isBuy = order.type === "buy";
                    const type = capitalize(order.type);
                    const status = capitalize(order.status);
                    return (
                      <Fragment>
                        <tr>
                          <td>{order?.userId?.name}</td>
                          <td className="with-icon">
                            <span
                              className={`td-icon-container ${
                                isBuy ? "receive" : "send"
                              }`}
                            >
                              {isBuy ? (
                                <CallMadeIcon className="table-icon" />
                              ) : (
                                <CallReceivedIcon className="table-icon" />
                              )}
                            </span>
                            <span className="td-icon-text icon-left">
                              {" "}
                              {type}
                            </span>
                          </td>
                          <td>{_amountSent}</td>
                          <td>{_amountReceive}</td>
                          <td>{status}</td>
                          <td>
                            <div className="action-row">
                              <Button
                                className="action-btn edit"
                                variant="contained"
                                onClick={() => onViewOrder(order)}
                              >
                                {" "}
                                <PreviewIcon />
                                <span> View</span>
                              </Button>
                            </div>
                          </td>
                        </tr>
                      </Fragment>
                    );
                  })
                )}
              </tbody>
            </table>
            {orderData.length < 1 && (
              <Fragment>
                <div className="no-transaction-container">
                  <img src={noTransactionImg} className="no-transaction-img" />
                  <div className="no-transaction-text">No Orders Found</div>
                </div>
              </Fragment>
            )}
          </div>
          <Pagination
            items={totalData}
            initialPage={orderFilter?.page}
            onChangePage={onChangeFilter}
            per_page={orderFilter?.limit}
          />
          {/* <Loader /> */}
        </Card>
      </div>
    </Fragment>
  );
};

export default withDashboard(Orders);
